async function getReplayEvent({
  client,
  scope,
  replayId: event_id,
  event,
}

) {
  // XXX: This event does not trigger `beforeSend` in SDK
  // @ts-ignore private api
  const preparedEvent = await client._prepareEvent(event, { event_id }, scope);

  if (preparedEvent) {
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getOptions() && client.getOptions()._metadata;
    const { name } = (metadata && metadata.sdk) || {};

    preparedEvent.sdk = {
      ...preparedEvent.sdk,
      version: "7.28.1",
      name,
    };
  }

  return preparedEvent;
}

export { getReplayEvent };
//# sourceMappingURL=getReplayEvent.js.map
